import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=f13df164&"
import script from "./ColumnHeader.vue?vue&type=script&lang=js&"
export * from "./ColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColumnHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports